const value = Object.freeze({
  Dashboard: 0,
  Summary: 1,
  Detail: 2
});
export default value;
